import request from '../utils/request'
export const getSummary = params => request.get('/dashboard/summary', { params })
export const getTodos = () => request.get('/dashboard/todos')
